import { all, call, fork, put, takeEvery, takeLatest, throttle, select } from 'redux-saga/effects'

import {
  SEARCH_CLIENTS,
  AUTOCOMPLETE_CLIENTS,
  AUTOCOMPLETE_MY_CLIENTS,
  SEARCH_MY_CLIENTS,
  EXPORT_MY_CLIENTS,
  EXPORT_MY_CLIENTS_SUCCESS,
  EXPORT_MY_CLIENTS_ERROR,
} from '../constants/ActionsTypes'

import { searchClients, searchMyClients, exportMyClientsRequest } from '../api/Clients'

import {
  searchClientsSuccess,
  autocompleteClientsSuccess,
  autocompleteMyClientsSuccess,
  searchMyClientsSuccess,
} from '../actions/Clients'

export const getCommonState = (state) => state.common

function* searchClientsRequest({ payload }) {
  const params = yield select(getCommonState)
  const { AdminActionBar } = params

  if (AdminActionBar.showRemove) {
    payload.borrado = AdminActionBar.showRemove
  }

  try {
    const clients = yield call(searchClients, payload)
    yield put(searchClientsSuccess(clients))
  } catch (error) {}
}

function* autocompleteClientsRequest({ payload }) {
  const params = yield select(getCommonState)
  const { AdminActionBar, currentFeature } = params

  const query = {
    filtro: payload,
    page: 1,
    pageSize: 10,
  }

  if (AdminActionBar.showRemove) {
    query.borrado = AdminActionBar.showRemove
  }

  if (currentFeature) {
    query.feature = currentFeature
  }

  try {
    const clients = yield call(searchClients, query)
    yield put(autocompleteClientsSuccess(clients))
  } catch (error) {}
}

function* autocompleteMyClientsRequest({ payload }) {
  const params = yield select(getCommonState)
  const { currentFeature } = params

  let filtro = payload
  let include = null
  let feature = currentFeature

  if (payload instanceof Object) {
    filtro = payload.filtro
    include = payload.include
    // Allow feature to be passed directly in payload, overriding the one from common state
    if (payload.feature) {
      feature = payload.feature
    }
  }

  const query = {
    filtro,
    page: 1,
    pageSize: 10,
    include,
  }

  if (feature) {
    query.feature = feature
  }

  try {
    const response = yield call(searchMyClients, query)
    yield put(autocompleteMyClientsSuccess(response))
  } catch (error) {}
}

export function* searchClientsSaga() {
  yield takeEvery(SEARCH_CLIENTS, searchClientsRequest)
}

export function* autocompleteClientsSaga() {
  yield throttle(1000, AUTOCOMPLETE_CLIENTS, autocompleteClientsRequest)
}

export function* autocompleteMyClientsSaga() {
  yield throttle(1000, AUTOCOMPLETE_MY_CLIENTS, autocompleteMyClientsRequest)
}

function* searchMyClientsRequest({ payload }) {
  try {
    const response = yield call(searchMyClients, payload)
    yield put(searchMyClientsSuccess(response))
  } catch (error) {}
}

export function* searchMyClientsSaga() {
  yield takeEvery(SEARCH_MY_CLIENTS, searchMyClientsRequest)
}

function* exportMyClientsSaga({ payload }) {
  try {
    yield call(exportMyClientsRequest, payload)
    yield put({ type: EXPORT_MY_CLIENTS_SUCCESS })
  } catch (error) {
    yield put({ type: EXPORT_MY_CLIENTS_ERROR, error })
  }
}

export function* exportMyClientsSagaWatcher() {
  yield takeLatest(EXPORT_MY_CLIENTS, exportMyClientsSaga)
}

export default function* rootSaga() {
  yield all([
    fork(searchClientsSaga),
    fork(autocompleteClientsSaga),
    fork(autocompleteMyClientsSaga),
    fork(searchMyClientsSaga),
    fork(exportMyClientsSagaWatcher),
  ])
}
